import { Action } from '@ngrx/store';

export enum ActionTypes {
  GET_REPORT_REQUEST = '[GET_REPORT] Request',
  GET_REPORT_SUCCESS = '[GET_REPORT] Success',
  GET_REPORT_FAILURE = '[GET_REPORT] Failure',
}

export class GetReportRequestAction implements Action {
  readonly type = ActionTypes.GET_REPORT_REQUEST;
  constructor(public loader: boolean) {}
}

export class GetReportSuccessAction implements Action {
  readonly type = ActionTypes.GET_REPORT_SUCCESS;
  constructor(public payload: any) {}
}

export class GetReportRequestFailureAction implements Action {
  readonly type = ActionTypes.GET_REPORT_FAILURE;
  constructor(public payload: { error: string }) {}
}

export type Actions = GetReportRequestAction | GetReportSuccessAction | GetReportRequestFailureAction;
